export const RSACAF_LESSONS_AR = [
  {
    id: 'rsacaf-1',
    numero: 1,
    titre: "مخصص RSA — الفهم والطلب",
    sousTitre: "حقوقك وأموالك",
    contexte: "دخلك محدود أو معدوم. مخصص RSA موجود لمساعدتك — لكن 30% من المستحقين لا يطلبونه.",
    explication: [
      "**مخصص RSA** (الدخل الأساسي للتضامن) هو مساعدة شهرية تدفعها CAF للأشخاص الذين لديهم دخل غير كافٍ، ابتداءً من سن 25 سنة.",
      "**المبلغ** في 2026: حوالي 635 أورو في الشهر لشخص وحيد. يتغير حسب وضعك العائلي ودخلك.",
      "**محاكاة مجانية**: اذهب إلى caf.fr أو mesaides.gouv.fr — نتيجة في 5 دقائق، مجهولة الهوية وبدون التزام.",
      "**لتقديم الطلب**: سجّل الدخول إلى caf.fr ← 'خدماتي الإلكترونية' ← 'تقديم طلب RSA'. الوثائق المطلوبة: وثيقة هوية، RIB، إثبات الإقامة، كشوف الحساب لآخر 3 أشهر.",
      "**إذا عدت إلى العمل**: يتناقص RSA تدريجياً — لا يتوقف فجأة. أخبر CAF بدخلك الجديد.",
    ],
    question: "تعتقد أنك مستحق لـ RSA. ما هي الخطوة الأولى؟",
    options: [
      { id: 'a', text: "إجراء محاكاة مجانية على caf.fr أو mesaides.gouv.fr", correct: true },
      { id: 'b', text: "التوجه مباشرة إلى CAF بجميع وثائقك", correct: false },
      { id: 'c', text: "انتظار أن تتصل بك CAF", correct: false },
    ],
    explication_reponse: "المحاكاة مجانية ومجهولة وبدون التزام. تعطيك تقديراً في 5 دقائق. ابدأ دائماً بذلك — لا شيء تخسره من التحقق من حقوقك.",
  },
  {
    id: 'rsacaf-2',
    numero: 2,
    titre: "المنح العائلية",
    sousTitre: "مساعدات للعائلات ذات الأطفال",
    contexte: "لديك أطفال. تدفع CAF عدة مساعدات حسب وضعك — أكثر مما تتوقع على الأرجح.",
    explication: [
      "**المنح العائلية الكلاسيكية**: تُدفع ابتداءً من طفلين معالين دون 20 سنة. المبلغ يعتمد على دخلك.",
      "**منحة الولادة**: حوالي 1000 أورو تُدفع في الشهر السابع من الحمل، بشروط الدخل. أخبر CAF بحملك قبل الشهر الثالث.",
      "**منحة القاعدة PAJE**: مساعدة شهرية من الولادة حتى 3 سنوات من عمر الطفل، بشروط الدخل.",
      "**مكمّل حرية اختيار طريقة الحضانة**: مساعدة إذا كان طفلك عند حاضنة أو حضانة معتمدة.",
      "**أداة أساسية**: caf.fr ← 'محاكاة حقوقي' للحصول على تقدير شامل لجميع المساعدات المستحقة لك.",
    ],
    question: "أنتِ حامل. متى يجب إخبار CAF؟",
    options: [
      { id: 'a', text: "قبل نهاية الشهر الثالث من الحمل", correct: true },
      { id: 'b', text: "عند ولادة الطفل", correct: false },
      { id: 'c', text: "في أي وقت، لا يوجد أجل", correct: false },
    ],
    explication_reponse: "الإعلان عن الحمل قبل الشهر الثالث يُفعّل جميع المساعدات. كل شهر تأخير قد يجعلك تخسرين حقوقاً — منحة الولادة تُدفع في الشهر السابع، لذا يجب الإعلان قبل ذلك.",
  },
  {
    id: 'rsacaf-3',
    numero: 3,
    titre: "الإعلان عن الدخل والتغييرات",
    sousTitre: "كل ثلاثة أشهر وعند كل حدث",
    contexte: "CAF تحتاج أن تُعلَم بوضعك في الوقت الفعلي. نسيان إعلان قد يوقف مساعداتك أو يخلق ديناً.",
    explication: [
      "**الإعلان الربع سنوي RSA**: إلزامي كل 3 أشهر (يناير، أبريل، يوليو، أكتوبر). إذا نسيت، يُوقف الصرف — لا يُفقد.",
      "**التغييرات التي يجب الإعلان عنها خلال 30 يوماً**: انتقال، ولادة، انفصال، استئناف أو فقدان عمل، تغيير في الدخل.",
      "**كيفية الإعلان**: على caf.fr ← 'حسابي' ← 'الإبلاغ عن تغيير' أو مباشرة عبر تطبيق CAF Mon Compte.",
      "**الدين**: إذا لم تُعلن واستمريت في تلقي مساعدات لم تعد مستحقاً لها، ستطلب منك CAF إعادة كل شيء.",
      "**الانفصال**: كل والد يفتح ملفه الخاص في CAF. المنح تذهب للوالد الحاضن.",
    ],
    question: "نسيت إعلانك الربع سنوي RSA. ماذا يحدث؟",
    options: [
      { id: 'a', text: "يُوقف الصرف حتى تُعلن — لا يُفقد نهائياً", correct: true },
      { id: 'b', text: "تخسر RSA لهذا الربع نهائياً", correct: false },
      { id: 'c', text: "CAF تُعلن تلقائياً عنك", correct: false },
    ],
    explication_reponse: "لا داعي للذعر عند النسيان — بمجرد أن تُعلن، يستأنف الصرف. ضع تذكيراً في هاتفك: يناير، أبريل، يوليو، أكتوبر.",
  },
  {
    id: 'rsacaf-4',
    numero: 4,
    titre: "استخدام الفضاء الإلكتروني لـ CAF",
    sousTitre: "إدارة كل شيء دون التنقل",
    contexte: "الفضاء الإلكتروني لـ CAF على caf.fr يتيح لك إدارة كل شيء من المنزل — شهادات، مدفوعات، مراسلات، إعلانات.",
    explication: [
      "**أنشئ حسابك** على caf.fr برقم المنتفع (على مراسلاتك مع CAF) وتاريخ ميلادك.",
      "**ما يمكنك فعله**: الاطلاع على مدفوعاتك، تنزيل شهاداتك، إرسال وثائق، الإبلاغ عن تغيير، محاكاة حقوقك.",
      "**شهادة CAF** تُثبت حقوقك — مطلوبة للمطعم المدرسي، الحضانة، السكن الاجتماعي. قابلة للتنزيل في 30 ثانية على caf.fr.",
      "**المراسلة الإلكترونية لـ CAF**: أرسل وثائق وأسئلة مباشرة لـ CAF الخاصة بك، دون انتظار هاتفي أو تنقل.",
      "**تطبيق CAF Mon Compte**: إشعارات الدفع، الشهادات، الإعلانات الربع سنوية — كل شيء من هاتفك.",
    ],
    question: "المدرسة تطلب شهادة CAF للمطعم المدرسي. أين تجدها بسرعة؟",
    options: [
      { id: 'a', text: "على caf.fr في فضائك الشخصي — قابلة للتنزيل في 30 ثانية", correct: true },
      { id: 'b', text: "بالتوجه إلى CAF مع وثيقة هوية", correct: false },
      { id: 'c', text: "بالاتصال بـ 3230 وانتظار رسالة بريدية", correct: false },
    ],
    explication_reponse: "شهادة CAF تُنزّل فورياً على caf.fr أو تطبيق الهاتف — متاحة 24/24. إنها من أكثر الوثائق التي يجب دائماً أن تكون في متناولك.",
  },
];
